import { render, staticRenderFns } from "./index5.vue?vue&type=template&id=6f0e8bf8&scoped=true&"
import script from "./index5.vue?vue&type=script&lang=js&"
export * from "./index5.vue?vue&type=script&lang=js&"
import style0 from "./index5.vue?vue&type=style&index=0&id=6f0e8bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e8bf8",
  null
  
)

export default component.exports